export const LEGAL_COMMUNITY_ENGAGEMENT: string = `

### <!--= ++sectionIndex -->. Community Engagement
<!-- subSectionIndex = 0; -->

<!-- if (engagement.community.discord) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Discord

We use the social platform Discord to facilitate community engagement and discussion. Discord is an instant messaging and digital distribution platform operated by Discord Inc., 3155 South Bascom Avenue, Campbell, California 95008, USA.

When you choose to participate in our community on Discord, please note that you will be required to agree to Discord's terms of service and privacy policy. Discord collects and processes user data, including but not limited to, user name, email address, IP address, and device information, as described in its Privacy Policy.

Participation in our Discord community is entirely optional. Please note that as Discord is an external platform, we do not have control over, or responsibility for, how Discord handles your data.

For more detailed information regarding the handling of user data, please refer to Discord's Privacy Policy, available at [Discord Privacy Policy,](https://discord.com/privacy).
<!-- } -->

<!-- if (engagement.community.facebook) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Facebook

We utilizes the social networking platform Facebook to build and engage with our online community. Facebook is a service provided by Facebook Inc., 1 Hacker Way, Menlo Park, California 94025, USA.

By choosing to join and participate in our Facebook community, please be aware that you are subject to Facebook's terms of service and privacy policy. Facebook collects, stores, and processes personal data of users following its own data use policy.

Participation in our Facebook community is entirely voluntary. Please note that as Facebook is an external platform, we do not have control over, or responsibility for, how Facebook handles your data.

For more detailed information about how Facebook handles user data, please refer to Facebook's Data Policy, available at [Facebook Data Policy](https://www.facebook.com/about/privacy/).
<!-- } -->
`;
